import { StudioAnimation, StudioCell } from '..';
import { CanvasService } from '../../../../services/canvas/canvas.service';

export interface LayoutCellDefinition extends StudioCell {
  shape?: string;
  metaKey?: 'row' | 'column' | 'card-row' | 'card-column' | 'grid';
  id?: string;
  type?: 'row' | 'column' | 'grid';
  gap?: number;
  children?: LayoutCellDefinition[];
}

export class LayoutCell {
  get id() {
    return this.definition.shape;
  }
  children: LayoutCell[] = [];
  absoluteDims: { w: number; h: number; x: number; y: number };
  constructor(
    public readonly cs: CanvasService,
    public readonly parent: LayoutCell,
    public readonly definition: LayoutCellDefinition,
  ) {
    this.children = (definition.children || []).map(
      child => new LayoutCell(this.cs, this, child),
    );
  }
  getAnimation(): StudioAnimation {
    let animation: StudioAnimation =
      this.id && this.id !== 'root'
        ? {
            target: this.id,
          }
        : undefined;

    switch (this.children.length) {
      case 0:
        return {
          type: 'appear',
          duration: 2,
          target: this.id,
          overlap: 0.5,
        };
      case 1:
        const childAnimation = this.children[0].getAnimation();
        if (!animation) {
          return childAnimation;
        }
        animation = {
          type: 'appear',
          duration: 2,
          target: this.id,
          next: {
            ...childAnimation,
            delay: 1.5,
          },
        };
        break;
      default:
        const children = this.children;
        const animations = children.map(child => child.getAnimation());
        animations.reverse();
        // -- // -- // -- // -- //
        // -- // -- //
        const childrenAnimations = animations.reduce((acc, animation, i) => {
          if (!acc) {
            return animation;
          }
          acc.delay = 0.3;
          animation.paralell = acc;
          return animation;
        }, {} as StudioAnimation);

        if (!animation) {
          return childrenAnimations;
        }
        animation = {
          type: 'appear',
          duration: 1,
          target: this.id,
          overlap: 0.5,
          next: {
            ...childrenAnimations,
            delay: 1.5,
          },
        };
        break;
    }

    return animation;
  }

  get shapeCells() {
    return {
      [this.id]: {
        ...this.absoluteDims,
        padding: this.definition.padding,
        background: this.definition.background,
        fontSize: this.definition.fontSize,
      },
      ...this.children.reduce(
        (object, child) => ({
          ...object,
          ...child.shapeCells,
        }),
        {},
      ),
    };
  }

  calChildrenDimns() {
    const { w, h, x, y } = this.absoluteDims;
    const { gap, padding, type } = this.definition;

    const _gap = gap || 0;
    const xGap = _gap;
    const yGap = _gap;

    let px = 0;
    let py = 0;

    if (padding) {
      if (Array.isArray(padding)) {
        [px, py] = padding;
      } else {
        px = padding || 0;
        py = padding || 0;
      }
    }

    const _px = px;
    const _py = py;
    // -- //
    let _x = x + _px;
    let _y = y + _py;

    const absWidth = w - 2 * _px;
    const absHeight = h - 2 * _py;

    const gapCnt = this.children.length - 1;
    let itemWidth = 0;
    let itemHeight = 0;
    switch (type) {
      case 'row':
        itemWidth = (absWidth - gapCnt * xGap) / this.children.length;
        itemHeight = absHeight;
        // -- //
        this.children.map(child => {
          child.absoluteDims = {
            x: _x,
            y: _y,
            w: itemWidth,
            h: itemHeight,
          };
          _x += itemWidth + xGap;
        });
        break;
      case 'column':
        console.log('absHeight', absHeight, 'gapCnt', gapCnt, 'yGap', yGap);
        itemWidth = absWidth;
        itemHeight = (absHeight - gapCnt * yGap) / this.children.length;
        this.children.map(child => {
          child.absoluteDims = {
            x: _x,
            y: _y,
            w: itemWidth,
            h: itemHeight,
          };
          _y += itemHeight + yGap;
        });
        break;
      case 'grid':
        break;
    }
    this.children.forEach(child => child.calChildrenDimns());
  }
}

export class RootLayoutCell extends LayoutCell {
  get id() {
    return 'root';
  }

  get dims() {
    const offset = this.cs.currentScreenX * 0.05;
    return {
      // w: this.cs._screenX - 2 * offset,
      // h: this.cs._screenY - 2 * offset,
      // x: offset,
      // y: offset,
      w: 1,
      h: 1,
      x: 0,
      y: 0,
    };
  }
  constructor(
    public readonly cs: CanvasService,
    definition: LayoutCellDefinition,
  ) {
    super(cs, null, definition);
    this.absoluteDims = {
      x: 0,
      y: 0,
      w: 1,
      h: 1,
    };
    this.calChildrenDimns();
    // TOOD - validation
    // paddings cannot be more than 50% of the screen
  }

  // getAnimation() {
  //   if (this.children.length == 1) {
  //     return this.children[0].getAnimation();
  //   }
  //   // -- // -- // -- //

  //   // const childrenTimelines = this.children.map(child => child.getAnimation());
  //   // childrenTimelines.forEach(child => {
  //   //   timeline.add(child);
  //   // });
  // }

  get cellsByShapeId(): Record<string, LayoutCell> {
    const result: Record<string, LayoutCell> = {};
    this.collectCellsByShapeId(this, result);
    return result;
  }

  private collectCellsByShapeId(
    cell: LayoutCell,
    result: Record<string, LayoutCell>,
  ): void {
    if (cell.definition.shape) {
      result[cell.definition.shape] = cell;
    }
    for (const child of cell.children) {
      this.collectCellsByShapeId(child, result);
    }
  }
}
